export type ValidateFunction = (value: any) => string | undefined;

// Primitive type checking for internal use
const isBoolean = (value: any) => typeof value === "boolean";
const isString = (value: any) => typeof value === "string";
const isNumber = (value: any) =>
  typeof value === "number" && !Number.isNaN(value);
const isArray = (value: any) => Array.isArray(value);
// const isRecord = (value: any) => typeof value === "object" && !isArray(value);

export const isEmptyOr = (or: ValidateFunction) => (value: any) => {
  if (isRequired(value)) {
    return;
  }
  return or(value);
};

// String validation
export const isRequired = (value: any) => {
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    (isArray(value) && value.length === 0)
  ) {
    return "This field is required";
  }
};

export const isMinStringLength = (minLength: number) => (value: any) => {
  if (!isString(value) || value.length < minLength) {
    return `This field needs to be at least ${minLength} characters`;
  }
};

export const isMaxStringLength = (maxLength: number) => (value: any) => {
  if (!isString(value) || value.length > maxLength) {
    return `This field needs to be at most ${maxLength} characters`;
  }
};

const emailRegex = new RegExp(
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i,
);
export const isEmail = (value: any) => {
  if (!isString(value) || !emailRegex.test(value)) {
    return `Please enter a valid email address`;
  }
};

const websiteRegex = new RegExp(
  /^https?:\/\/(?:www\.)?[-a-z0-9@:%._\+~#=]{1,256}\.[a-z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/i,
);
export const isWebsite = (value: any) => {
  if (!isString(value) || !websiteRegex.test(value)) {
    return `Please enter a valid website address (e.g https://www.google.com)`;
  }
};

// Number validation
export const isGreaterThanNumber = (minNumber: number) => (value: any) => {
  if (!isNumber(value) || value < minNumber) {
    return `Please enter a number greater than ${minNumber}`;
  }
};

export const isLessThanNumber = (maxNumber: number) => (value: any) => {
  if (!isNumber(value) || value > maxNumber) {
    return `Please enter a number smaller than ${maxNumber}`;
  }
};

// Array validation

export const isMinArrayLength = (minLength: number) => (value: any) => {
  if (!isArray(value) || value.length < minLength) {
    return `Please select at least ${minLength} options`;
  }
};

export const isMaxArrayLength = (maxLength: number) => (value: any) => {
  if (!isArray(value) || value.length > maxLength) {
    return `Please select at most ${maxLength} options`;
  }
};

// Boolean validation

export const isTrue = (value: any) => {
  if (!isBoolean(value) || value === false) {
    return `Please check this`;
  }
};
